import React, {useEffect, useState, useContext} from 'react';
import {BrowserRouter, Link, Route, Routes, Navigate } from 'react-router-dom';
import Admin from './pages/Admin/Admin';
import CurrentWeek from './pages/CurrentWeek/CurrentWeek';
import EnterPicks from './pages/EnterPicks/EnterPicks';
import Standings from './pages/Standings/Standings';
import Rules from './pages/Rules/Rules';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Account } from './components/UserPool/Account';
import Login from './components/UserPool/Login';
import { AccountContext } from './components/UserPool/Account';
import Breakdown from './pages/Breakdown/Breakdown';
import PastChampions from './pages/PastChampions/PastChampions';

function App() {

  const { getSession } = useContext(AccountContext);
  const [newSession, setNewSession] = useState(undefined);
  const [status, setStatus] = useState(false);
  const [currYear, setCurrYear] = useState(sessionStorage.getItem("currYear") ?? '2026' );
  const [currPage, setCurrPage] = useState(sessionStorage.getItem("currPage") ?? 'Enter Picks' );
  
  const NavItemComponents = []
   
  NavItemComponents.push(<NavDropdown.Item onClick={() => {setCurrPage('Enter Picks'); sessionStorage.setItem('currPage', 'Enter Picks')}} as={Link} to='/enterPicks'>Enter Picks</NavDropdown.Item>)
  NavItemComponents.push(<NavDropdown.Item onClick={() => {setCurrPage('Breakdown'); sessionStorage.setItem('currPage', 'Breakdown')}} as={Link} to='/breakdown'>Breakdown</NavDropdown.Item>)
  NavItemComponents.push(<NavDropdown.Item onClick={() => {setCurrPage('Current Week'); sessionStorage.setItem('currPage', 'Current Week')}} as={Link} to='/currentWeek'>Current Week</NavDropdown.Item>)
  NavItemComponents.push(<NavDropdown.Item onClick={() => {setCurrPage('Standings'); sessionStorage.setItem('currPage', 'Standings')}} as={Link} to='/standings'>Standings</NavDropdown.Item>)
  NavItemComponents.push(<NavDropdown.Item onClick={() => {setCurrPage('Past Champions'); sessionStorage.setItem('currPage', 'Past Champions')}} as={Link} to='/pastChampions'>Past Champions</NavDropdown.Item>)
  NavItemComponents.push(<NavDropdown.Item onClick={() => {setCurrPage('Rules'); sessionStorage.setItem('currPage', 'Rules')}} as={Link} to='/rules'>Rules</NavDropdown.Item>)
  
  const [NavItems, setNavItems] = useState(NavItemComponents)

  const RouteComponents = []

  RouteComponents.push(<Route path='/login' element={<Login year={currYear} authmode={'signin'}/>} />)
  RouteComponents.push(<Route path='/breakdown' element={<Breakdown year={currYear} />}/>)
  RouteComponents.push(<Route path='/currentWeek' element={<CurrentWeek year={currYear} />}/>)
  RouteComponents.push(<Route path='/enterPicks' element={<EnterPicks year={currYear} />}/>)
  RouteComponents.push(<Route path='/standings' element={<Standings year={currYear} />}/>)
  RouteComponents.push(<Route path='/pastChampions' element={<PastChampions/>}/>)
  RouteComponents.push(<Route path='/rules' element={<Rules/>}/>)
  RouteComponents.push(<Route path='/' element={<EnterPicks year={currYear} userInfo={newSession}/>}/>)
  RouteComponents.push(<Route path='*' element={<Navigate to='/' replace={true} />}/>)
  
  const [RouteItems, setRouteItems] = useState(RouteComponents)


  useEffect(() => {
    getSession(setNewSession)
      .then((session) => {
        console.log('Session Activated');
        setStatus(true);        
      })
      .catch((err) => {
        console.log('Session: ', err);
        setStatus(false)
      });
  }, []);

  useEffect(() => {
      if(newSession && newSession['idToken']['payload']['cognito:groups'] && newSession['idToken']['payload']['cognito:groups'][0] === 'admin') {
        console.log(newSession['idToken']['payload']['cognito:groups'])
        console.log('IS ADMIN')

        const newNavItems = NavItems
        newNavItems.push(<NavDropdown.Item onClick={() => {setCurrPage('Admin'); sessionStorage.setItem('currPage', 'Admin')}} id='admin-link' as={Link} to='/admin'>Admin</NavDropdown.Item>)
        setNavItems(newNavItems)

        const newRouteItems = RouteItems
        newRouteItems.push(<Route path='/admin' element={<Admin year={currYear} />}/>)
        setRouteItems(newRouteItems)
      }
  }, [newSession]);

  if(!status) {
    return (
      <BrowserRouter>
            <Navbar fixed='top' bg='dark' variant='dark' style={{right:'0'}}>
              <Container>
                <Navbar.Brand href='/' style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  <img src='/bears.png' alt='' style={{width: '24px', height: '24px', objectFit: 'contain'}} />
                  House of Paign
                </Navbar.Brand>
                  <Nav className='m-auto' style={{paddingRight: '100px'}}>
                    <Nav.Link id='account-id' reloadDocument style={{position: 'absolute', right: '5px', bottom: '10px'}} as={Link} to='/login'>Sign In</Nav.Link>
                  </Nav>
              </Container>
            </Navbar>
            <Routes>
              <Route path='/register' element={<Login year={currYear} authmode={'signup'}/>} />
              <Route path='/login' element={<Login year={currYear} authmode={'signin'}/>} />
              <Route path='/' element={<Login year={currYear} authmode={'signin'}/>} />
              <Route index element={<Login year={currYear} authmode={'signin'}/>} />
            </Routes>
          </BrowserRouter>
    )
  }

  console.log(NavItems)
  return (

        <Account>
          <BrowserRouter>
            <Navbar collapseOnSelect expand='sm' bg='dark' variant='dark' id='main-navbar'>
              <Container >

                <Navbar.Brand style={{paddingLeft:'50px', fontSize: '20px', display: 'flex', alignItems: 'center', gap: '10px'}} href='/'>
                  <img src='/bears.png' alt='' style={{width: '28px', height: '28px', objectFit: 'contain'}} />
                  House of Paign
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{marginRight: '20px'}}/>

                <Navbar.Collapse id="navbar-dark-example" style={{marginLeft: '50px'}}>
                  <Nav>
                    <NavDropdown
                      id="nav-dropdown-dark-example"
                      title={currPage}
                      menuVariant="dark"
                      style={{fontSize: '18px'}}
                    >
                      {
                        NavItems
                      }
                     
                      {/* <NavDropdown.Item onClick={() => {setCurrPage('Admin'); sessionStorage.setItem('currPage', 'Admin')}} id='admin-link' as={Link} to='/admin'>Admin</NavDropdown.Item> */}
                    </NavDropdown>
                    </Nav>
                    <Nav>
                    <NavDropdown
                      id="nav-dropdown-dark-example"
                      title={currYear}
                      menuVariant="dark"
                      style={{fontSize: '18px'}}
                    >
                      <NavDropdown.Item onClick={() => {setCurrYear('2026'); sessionStorage.setItem('currYear', '2026'); window.location.reload();}}>2026</NavDropdown.Item>
                      <NavDropdown.Item onClick={() => {setCurrYear('2025'); sessionStorage.setItem('currYear', '2025'); window.location.reload();}}>2025</NavDropdown.Item>
                      <NavDropdown.Item onClick={() => {setCurrYear('2024'); sessionStorage.setItem('currYear', '2024'); window.location.reload();}}>2024</NavDropdown.Item>
                      <NavDropdown.Item onClick={() => {setCurrYear('2023'); sessionStorage.setItem('currYear', '2023'); window.location.reload();}}>2023</NavDropdown.Item>
                      <NavDropdown.Item onClick={() => {setCurrYear('2022'); sessionStorage.setItem('currYear', '2022');  window.location.reload();}}>2022</NavDropdown.Item>
                    </NavDropdown>
                  </Nav>
                  <Nav style={{paddingRight: '20px'}}>
                    <Nav.Link  style={{fontSize: '18px'}} id='account-id' reloadDocument as={Link} to='/login'>Sign In</Nav.Link>
                  </Nav>
                </Navbar.Collapse>                  
              </Container>
            </Navbar>
            <Routes>
              {
                RouteItems
              }
            </Routes>
          </BrowserRouter>
        </Account>

  );
}

export default App;
